import React, {useRef, useState} from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Axios from 'axios';


const Login = ({
	onSuccess,
	onError,
}) => {
	// username
	const [user, setUser] = useState();
	const userInput = (
		<Form.Control
			className = {'my-2'}
			placeholder = {'Email-Adresse'}
			required = {true}
			onChange = {ev => {
				ev.preventDefault();
				setUser(ev.target.value);
			}}
			autoFocus = {true}
			value = {user || ''}/>
	);


	// password
	const [password, setPassword] = useState();
	const passwordInput = (
		<Form.Control
			className = {'my-2'}
			placeholder = {'Passwort'}
			type = {'password'}
			required = {true}
			onChange = {ev => {
				ev.preventDefault();
				setPassword(ev.target.value);
			}}
			value = {password || ''}/>
	);


	// xsrf
	const xsrfRef = useRef();
	const xsrfInput = (
		<input ref = {xsrfRef}
			id = {'xsrf-field'}
			type = {'hidden'}
			name = {'_csrf'}/>
	);

	const onSubmit = ev => {
		ev.preventDefault();

		if (!(user && password))
			return;

		const xsrfToken = document.cookie
			.split(';')
			.map(c => c.trim())
			.find(c => c.startsWith('XSRF-TOKEN'))
			.split('=')[1];

		Axios.post('/processLogin', null, {
			params: {
				username: user,
				password: password,
			},
		}).then(
			() => onSuccess(true),
			rejected => {
				setUser("");
				setPassword("");
				onError("Ungültige Login-Daten");
			});
	};


	// render
	return (
		<Form className = {'form-signin'}
			onSubmit = {onSubmit}>
			<h2 className = {'text-center'}>Bitte anmelden</h2>
			{userInput}
			{passwordInput}
			{xsrfInput}
			<Button
				className = {'mt-1'}
				type = {'submit'}
				disabled = {!(user && password)}>
				{'Anmelden'}
			</Button>
		</Form>
	);
};

export default Login;
